import { connect } from 'react-redux';
import debounce from 'lodash/debounce';
import InstitutionAutoCompleteView from './InstitutionAutocompleteView';
import * as selectors from './InstitutionAutoCompleteSelectors';
import * as actions from './InstitutionAutoCompleteActions';
import { currentClientSelector } from '../CommonSelectors/CommonAreaSelector';

const debouncedFetchInstitutions = debounce((dispatch, clientId, term) => {
  if (term.length > 0) {
    dispatch(actions.fetchInstitutions(clientId, term));
  }
}, 300);

const mapStateToProps = state => ({
  currentClient: currentClientSelector(state),
  errors: selectors.errorsSelector(state),
  institutions: selectors.institutionsSelector(state),
  isLoading: selectors.isLoadingSelector(state),
  querySelectorTerm: selectors.querySelectorTerm(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  setInstitutions: institutions => dispatch(actions.setInstitutions(institutions)),
  fetchInstitutions: debouncedFetchInstitutions.bind(null, dispatch),
  onChange: result => {
    if (result.value) {
      dispatch(actions.setInstitutions([]));
    }

    ownProps.onChange(result);
  },
  setTermQuery: queryTerm => dispatch(actions.setTermQuery(queryTerm)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InstitutionAutoCompleteView);
